import type { PhotoEffectHistoryGesture } from './types/photo-effect-history-gesture'

export function buildPhotoEffectHistoryTxnId(
  shapeId: string,
  sessionId: number,
  gesture: PhotoEffectHistoryGesture,
  gestureSeq: number
): string {
  return `photo-effects:${shapeId}:${sessionId}:${gesture}:${gestureSeq}`
}
